// When converting from excel sheet into json. If paragraph contains a breakline then while conversion
// it converted to "\n". So this code will add <br /> tags.
import { Fragment } from "react";
import { renderHTML } from "util/DomHelper";
import AddLinkFromContent from "./AddLinkFromContent";

function Content(props) {
  const { content, article } = props;
  const stringifyContent = content?.toString().split("\n");

  if (article) {
    return (
      <div
        dangerouslySetInnerHTML={renderHTML(article)}
      />
    );
  }
  return (
    <>
      {stringifyContent?.map((eachContent: string, index: number) => {
        if (eachContent) {
          return (
            <Fragment key={eachContent}>
              <AddLinkFromContent content={eachContent} />
              {index !== stringifyContent.length - 1 && (
                <>
                  <br />
                </>
              )}
            </Fragment>
          );
        }
        return null;
      })}
    </>
  );
}

export default Content;
